import { ExclamationIcon } from "@heroicons/react/solid"
import { toast } from "react-toastify"
import Toast from "../components/Toast"

export default (error) => {
  toast(<Toast icon={<ExclamationIcon className="h-6 w-6 text-red-500" />} headline="Error" text={error.message} />)
}